module.exports = __webpack_public_path__ + "static/img/诗仙会客厅2.87860f79.png";